<template>
  <v-card
      class="mx-auto"
      max-width="400"
      color="#303030"
  >
    <v-img
        class=" white--text align-end"
        height="200px"
        :src="post.url"

    ></v-img>

    <v-card-text class="text--primary">
      <div>r/{{ post.subreddit }}</div>
    </v-card-text>

    <v-card-actions>
      <v-row>
        <v-col cols="12" md="6">
          <v-btn
              color="orange"
              text
              :href="`https://redd.it/` + post.post_id"
              target="_blank"
          >
            View
          </v-btn>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn
              color="orange"
              text
              @click="openSearch"
          >
            Search
          </v-btn>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "PostCard",
  props: {
    post: Object,
    searchData: Object
  },
  methods: {
    openSearch() {
      let queryParams = {
        postId: this.searchData.post_id,
        memeFilter: this.searchData.memeFilter ? 'true' : 'false',
        sameSub: this.searchData.sameSub ? 'true' : 'false',
        filterDeadMatches: this.searchData.filterDeadMatches ? 'true' : 'false',
        filterOnlyOlder: this.searchData.filterOnlyOlder ? 'true' : 'false',
        targetImageMatch: this.searchData.targetImageMatch,
        targetImageMemeMatch: this.searchData.targetImageMemeMatch
      }
      let routeData = this.$router.resolve({name: 'Search', query: queryParams});
      window.open(routeData.href, '_blank');
    },
  },
  computed: {
    displayButtonText: function () {
      switch (this.$vuetify.breakpoint.name) {
        case 'xs': return false
        case 'sm': return false
        case 'md': return false
        case 'lg': return true
        case 'xl': return true
      }
      return true;
    }
  }
}
</script>

<style scoped>

</style>